import { render, staticRenderFns } from "./VideoIconsHolder.vue?vue&type=template&id=ff38aa66&scoped=true&"
import script from "./VideoIconsHolder.vue?vue&type=script&lang=js&"
export * from "./VideoIconsHolder.vue?vue&type=script&lang=js&"
import style0 from "./VideoIconsHolder.vue?vue&type=style&index=0&id=ff38aa66&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff38aa66",
  null
  
)

export default component.exports